import React from 'react';
import {useSingleListing} from "../context/SingleListingProvider.tsx";
import useCtrMetaFields from "../../hooks/useCtrMetaFields.tsx";
import {CtrDynamicTables, CtrInscriptions} from "../../graphql/generated/graphql-main.tsx";
import {useWpContext} from "../context/WordPressProvider.tsx";

type Props = {}
const ListingTabInclExcl = (props: Props) => {
    const {is_fr} = useWpContext();
    const {listing: lst} = useSingleListing();
    const {toHtml} = useCtrMetaFields();
    const elem = toHtml<CtrInscriptions>(lst, CtrDynamicTables.Inscriptions);

    return <dl className={"space-y-4"}>
        <div>
            {elem(is_fr ? "INCLUS_FRANCAIS" : "INCLUS_ANGLAIS")}
        </div>
        <div>
            {elem(is_fr ? "EXCLUS_FRANCAIS" : "EXCLUS_ANGLAIS")}
        </div>
    </dl>;
};

export default ListingTabInclExcl;
